import React from 'react';
import { Users, BookCopy, Star, Globe } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-emerald-950/40 text-emerald-100 py-2.5 px-3 border-y border-emerald-800/40 relative z-20" data-id="element-245">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-[10px] md:text-xs font-bold text-center uppercase tracking-wide" data-id="element-246">
        <div className="flex items-center" data-id="element-247">
          <Users className="w-3 h-3 md:w-4 md:h-4 mr-1 text-emerald-400" data-id="element-248" />
          <span data-id="element-249">+5.000 docentes confían</span>
        </div>
        <span className="hidden md:inline opacity-30" data-id="element-250">|</span>
        <div className="flex items-center" data-id="element-251">
          <BookCopy className="w-3 h-3 md:w-4 md:h-4 mr-1 text-emerald-400" data-id="element-252" />
          <span data-id="element-253">6 tomos premium</span>
        </div>
        <span className="hidden md:inline opacity-30" data-id="element-254">|</span>
        <div className="flex items-center" data-id="element-255">
          <Star className="w-3 h-3 md:w-4 md:h-4 mr-1 fill-current text-emerald-400" data-id="element-256" />
          <span data-id="element-257">4,9/5 calificación</span>
        </div>
        <span className="hidden md:inline opacity-30" data-id="element-258">|</span>
        <div className="flex items-center" data-id="element-259">
          <Globe className="w-3 h-3 md:w-4 md:h-4 mr-1 text-emerald-400" data-id="element-260" />
          <span data-id="element-261">Todo el mundo hispanohablante</span>
        </div>
      </div>
    </div>;
}